import { render, staticRenderFns } from "./PsgPanel.vue?vue&type=template&id=81781712&scoped=true&"
import script from "./PsgPanel.vue?vue&type=script&lang=js&"
export * from "./PsgPanel.vue?vue&type=script&lang=js&"
import style0 from "./PsgPanel.vue?vue&type=style&index=0&id=81781712&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81781712",
  null
  
)

export default component.exports